module.exports = __webpack_public_path__ + "img/loca_auto_bg.2f84d6e8.png";